/* eslint-disable linebreak-style */
import React from 'react';

function Categories() {
  return (
    <div className="container mx-auto py-16 px-24">
      <h1 className="text-2xl font-semibold">Under construction</h1>
    </div>
  );
}

export default Categories;
